const t=(t,n,o)=>{const r=n-t;return 0===r?1:(o-t)/r};export{t as progress};
